import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, Typography, makeStyles, Container, Box, CircularProgress, CardContent, Card } from '@material-ui/core';
import Layout from '../Layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PLI1 from '../../images/PLI1.jpg'
import PLI2 from '../../images/PLI2New.png'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getMasterTableData } from '../../ReduxStore/MastertableSlice';
import { PliPostLog, PLIUploadFile } from '../../ReduxStore/AssetDisposalSlice';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        maxWidth: 800,
        margin: '0 auto',
        paddingBlock: 10,
        marginTop: 5,
        marginBottom: 5
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formControl: {
        // marginBottom: theme.spacing(2),
    },
    button: {
        // marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    instructionCard: {
        marginBottom: theme.spacing(3),
        backgroundColor: '#f5f5f5', // Light background color for the instruction card
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
    },
    instructionText: {
        marginBottom: theme.spacing(1),
    }
}));



const PLIForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const asset_no = pathname[2];

    const [masterData, setMasterData] = useState();
    const [loading, setLoading] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [formData, setFormData] = useState({
        assetName: '',
        name: '',
        designation: '',
        model: '',
        serial: '',
        manufacturer: '',
        assetCode: '',
        location: '',
        invoice: '',
        invoiceDate: '',
        description: '',
        vendor: '',
        status: '',
        amountCapitalized: '',

    });
    const [fileData, setFileData] = useState({
        files: [],
    });
    const [imagePreviews, setImagePreviews] = useState([]);
    const [uploading, setUpLoading] = useState(false);
    const username = localStorage.getItem("username");
    const [formErrors, setFormErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            { key: 'assetName', label: 'Machine/ Asset Name' },
            { key: 'model', label: 'Model' },
            { key: 'serial', label: 'Serial' },
            { key: 'manufacturer', label: 'Make/ Manufacturer' },
            { key: 'assetCode', label: 'Fixed Asset Code/ Asset ID' },
            { key: 'location', label: 'Current Location' },
            { key: 'invoice', label: 'Invoice' },
            { key: 'invoiceDate', label: 'Invoice Date' },
            { key: 'description', label: 'Description of Asset as per Invoice' },
            { key: 'vendor', label: 'Name of Seller/ Vendor' },
            { key: 'status', label: 'Status' },
            { key: 'amountCapitalized', label: 'Amount Capitalized (₹)' },
        ];

        requiredFields.forEach(({ key, label }) => {
            if (!formData[key]) {
                newErrors[key] = `${label} is required.`;
            }
        });

        setFormErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const MAX_IMAGES = 3;  // Define max number of images

    const handleFileChange = (event) => {

        const allowedExtensions = ['jpeg', 'jpg', 'gif', 'png', 'tiff', 'bmp'];

        const selectedFiles = Array.from(event.target.files); // Convert FileList to an array

        const validatedFiles = selectedFiles.filter((file) => {

            const fileName = file.name;
            // Validate for double extensions
            const fileParts = fileName.split('.');
            if (fileParts.length !== 2) {
                toast.info('Invalid file name. Ensure it has only one valid extension.');
                return false;
            }

            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                toast.info(`File "${file.name}" has an invalid extension.`);
                return false;
            }

            if (!file.type.startsWith('image/')) {
                toast.info(`File "${file.name}" is not a valid image.`);
                return false;
            }

            // if (file.size > MAX_FILE_SIZE) {
            //     alert(`File "${file.name}" exceeds the maximum size of 5 MB.`);
            //     return false;
            // }

            if (file.name.startsWith('.')) {
                toast.info(`File "${file.name}" is not allowed.`);
                return false;
            }

            // if (isDuplicateFile(file, fileData.files)) {
            //     alert(`File "${file.name}" has already been added.`);
            //     return false;
            // }

            return true;
        });


        // Check if adding these files would exceed the maximum limit
        setFileData((prevState) => {
            const totalImages = prevState.files.length + validatedFiles.length;
            if (totalImages > MAX_IMAGES) {
                toast.info(`You can only upload up to ${MAX_IMAGES} images.`)
                return prevState; // Return current state, don't add more images
            }

            // Merge existing files with newly selected image files if under limit
            return {
                files: [...prevState.files, ...validatedFiles],
            };
        });

        // Read files as base64 if under the limit
        const newPreviews = [];
        const readerPromises = validatedFiles.map(file => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    newPreviews.push(reader.result); // Push base64 image data
                    resolve();
                };
                reader.onerror = reject;
                reader.readAsDataURL(file); // Read as base64
            });
        });

        // Update image previews once all files are read
        Promise.all(readerPromises)
            .then(() => {
                setImagePreviews((prevPreviews) => {
                    if (prevPreviews.length + newPreviews.length > MAX_IMAGES) {
                        return prevPreviews; // Don't add more previews if limit exceeded
                    }
                    return [...prevPreviews, ...newPreviews]; // Append new previews to existing ones
                });
            })
            .catch(error => {
                console.error("Error reading files:", error);
            });
    };


    // const handleFileChange = (event) => {
    //     const selectedFiles = Array.from(event.target.files); // Convert FileList to an array

    //     // Only accept image files (JPEG, PNG)
    //     const imageFiles = selectedFiles.filter(file => file.type.startsWith('image/'));

    //     // Merge existing files with newly selected image files
    //     setFileData((prevState) => ({
    //         files: [...prevState.files, ...imageFiles],
    //     }));

    //     // Read files as base64
    //     const newPreviews = [];
    //     const readerPromises = imageFiles.map(file => {
    //         return new Promise((resolve, reject) => {
    //             const reader = new FileReader();
    //             reader.onloadend = () => {
    //                 newPreviews.push(reader.result); // Push base64 image data
    //                 resolve();
    //             };
    //             reader.onerror = reject;
    //             reader.readAsDataURL(file); // Read as base64
    //         });
    //     });

    //     // Update image previews once all files are read
    //     Promise.all(readerPromises)
    //         .then(() => {
    //             setImagePreviews((prevPreviews) => [...prevPreviews, ...newPreviews]); // Append new previews to existing ones
    //         })
    //         .catch(error => {
    //             console.error("Error reading files:", error);
    //         });
    // };


    // Function to remove image preview and file
    const handleRemoveImage = (index) => {
        setImagePreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
        setFileData((prevState) => ({
            files: prevState.files.filter((_, i) => i !== index),
        }));
    };




    const getBase64ImageFromURL = (url) => {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.setAttribute('crossOrigin', 'anonymous'); // Handle CORS for images
            img.src = url;
            img.onload = () => {
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/jpeg'); // Or 'image/png'
                resolve(dataURL);
            };
            img.onerror = (error) => reject(error);
        });
    };

    const PLIFileUpload = async (log_id) => {
        try {
            setUpLoading(true);
            // Loop through each selected file
            for (const file of fileData.files) {
                const formData = new FormData();
                formData.append(file.name, file);
                formData.append('pli_logs_id', log_id);

                // Dispatch the action to upload each file
                const action = dispatch(PLIUploadFile(formData));
                const res = await action.unwrap();
                console.log("res from pv log:", res);

                if (res.StatusCode === 200) {
                    toast.success(`${file.name} Upload Done`);
                } else {
                    toast.error(`Something went wrong with ${file.name}!`);
                }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setUpLoading(false);
        }
    };



    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const payload = {
    //         submitby_name: "",
    //         submitby_dept: "",
    //         vendor_no: masterData['Vendor Code'],
    //         asset_no: masterData['asset_no'],
    //         form_data: {
    //             asset_name: formData.assetName,
    //             model: formData.model,
    //             serial_no: formData.serial,
    //             make: formData.manufacturer,
    //             asset_code_rfid: formData.assetCode,
    //             installation_location: formData.location,
    //             invoice_no: formData.invoice,
    //             invoice_date: formData.invoiceDate,
    //             asset_description: formData.description,
    //             vendor_no: formData.vendor,
    //             status: formData.status,
    //             amount_capitalized: formData.amountCapitalized
    //         }
    //     }
    //     console.log("check Payload", payload)

    //     try {
    //         setPostLoading(true)
    //         const action = dispatch(PliPostLog(payload));
    //         const res = await action.unwrap();
    //         console.log("res", res.result)
    //         if (res.StatusCode === 201) {
    //             if (fileData.files.length > 0) {
    //                 await PLIFileUpload(res.result.id);
    //                 // await SignatureUpload(res.result.id)
    //             }
    //             setPostLoading(false)
    //             toast.success("PLI Requested!");
    //             // generatePDF();
    //             setTimeout(() => {
    //                 navigate(`/pli-history/${asset_no}`);
    //             }, 2000);
    //         }
    //     } catch (error) {
    //         console.error("Error in okHandler:", error);
    //         toast.error(error.message || "Something went wrong!");
    //     } finally {
    //         setPostLoading(false)
    //     }
    // };

    // const generatePDF = async () => {
    //     const doc = new jsPDF();
    //     // Convert images to base64
    //     const base64Icon1 = await getBase64ImageFromURL(PLI1);
    //     const base64Icon2 = await getBase64ImageFromURL(PLI2);

    //     // Add icons in the top corners with smaller size (15x15)
    //     doc.addImage(base64Icon1, 'JPEG', 20, 10, 15, 15);  // Left top corner
    //     doc.addImage(base64Icon2, 'JPEG', 170, 10, 15, 15); // Right top corner

    //     // Title: "Annexure-V-C: Photos of Site Visit"
    //     doc.setFontSize(12);  // Reduced font size for title
    //     doc.text('Annexure-V-C: Photos of Site Visit', 20, 35); // Adjust positioning after icons

    //     // Adding Instructions
    //     doc.setFontSize(10);
    //     doc.text('Photographs should include the following:', 20, 45);
    //     doc.text('• Few photos of factory entrance with GPS coordinates.', 20, 50);
    //     doc.text('• External and internal view of factory including manufacturing operations.', 20, 55);
    //     doc.text('• Photo of visiting team from CE and Company officials.', 20, 60);
    //     doc.text('• A one-page note covering capex items – sample of at least 30 high value/critical items:', 20, 65);


    //     // Dynamically populate table data from formData or masterData
    //     const tableBody = [
    //         ['1', 'Machine/ Asset Name', formData.assetName || 'N/A'],
    //         ['2', 'Model#', formData.model || 'N/A'],
    //         ['3', 'Serial#', formData.serial || 'N/A'],
    //         ['4', 'Make/ Manufacturer', formData.manufacturer || 'N/A'],
    //         ['5', 'Fixed Asset Code/ Asset ID', formData.assetCode || 'N/A'],
    //         ['6', 'Building where installed', formData.location || 'N/A'],
    //         ['7', 'Invoice#', formData.invoice || 'N/A'],
    //         ['8', 'Invoice date', formData.invoiceDate || 'N/A'],
    //         ['9', 'Description of Asset as per Invoice', formData.description || 'N/A'],
    //         ['10', 'Name of Seller/ Vendor', formData.vendor || 'N/A'],
    //         ['11', 'Status', formData.status || 'N/A'],
    //         ['12', 'Amount Capitalized (₹)', formData.amountCapitalized || 'N/A'],
    //     ];


    //     doc.autoTable({
    //         startY: 75,  // Positioned after the instructions
    //         head: [['#', 'Particulars', 'Details']],
    //         body: tableBody,
    //         theme: 'grid',
    //         headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
    //         margin: { top: 75, left: 20, right: 20 },
    //         styles: { fontSize: 9 },  // Reduce font size in the table to save space
    //     });

    //     // Add Photo of Asset section
    //     doc.text('Photo of Asset:', 20, doc.lastAutoTable.finalY + 10);

    //     // Define starting position for the images
    //     let xPos = 20; // X-coordinate of the first image
    //     let yPos = doc.lastAutoTable.finalY + 15; // Y-coordinate below the "Photo of Asset" heading
    //     const imageWidth = 35; // Width of each image
    //     const imageHeight = 35; // Height of each image
    //     const margin = 8; // Margin between images

    //     // Add each image in a row
    //     for (let i = 0; i < imagePreviews.length; i++) {
    //         const imgDataUrl = imagePreviews[i]; // Image URL from the state

    //         // Add image to PDF
    //         try {
    //             await doc.addImage(imgDataUrl, 'JPEG', xPos, yPos, imageWidth, imageHeight);
    //         } catch (error) {
    //             console.error('Error adding image to PDF:', error);
    //         }

    //         // Update the xPos for the next image (adjust based on image width and margin)
    //         xPos += imageWidth + margin;

    //         // If the next image will overflow the page width, move to the next row
    //         if (xPos + imageWidth > doc.internal.pageSize.getWidth() - 20) {
    //             xPos = 20; // Reset to start of the row
    //             yPos += imageHeight + margin; // Move down to the next row
    //         }
    //     }
    //     // Ensure enough space between the last image and the signature section
    //     yPos += imageHeight + margin;

    //     // Save the PDF
    //     doc.save('PLI_Form.pdf');
    // };

    const generatePDF = async () => {
        const doc = new jsPDF();
        // Convert images to base64
        const base64Icon1 = await getBase64ImageFromURL(PLI1);
        const base64Icon2 = await getBase64ImageFromURL(PLI2);

        // Add icons in the top corners with smaller size (15x15)
        doc.addImage(base64Icon1, 'JPEG', 20, 10, 15, 15);  // Left top corner
        doc.addImage(base64Icon2, 'JPEG', 170, 10, 15, 15); // Right top corner

        doc.setFontSize(12); // Set font size for title
        doc.setFont("helvetica", "bold"); // Set font to bold
        doc.text('Annexure-V-C: Photos of Site Visit', 20, 35); // Adjust positioning after icons
        doc.setFont("helvetica", "normal"); // Reset to normal font for subsequent text

        // Adding Instructions
        doc.setFontSize(10);
        // Make the first instruction bold
        doc.setFont("helvetica", "bold");
        doc.text('Photographs should include the following:', 20, 45);
        doc.setFont("helvetica", "normal"); // Reset to normal font for subsequent text

        doc.text('• Few photos of factory entrance with GPS coordinates.', 20, 50);
        doc.text('• External and internal view of factory including manufacturing operations.', 20, 55);
        doc.text('• Photo of visiting team from CE and Company officials.', 20, 60);
        doc.text('• A one-page note covering capex items – sample of at least 30 high value/critical items:', 20, 65);

        // Add the heading for the table just above the table
        doc.setFontSize(12); // Set the font size for the heading
        doc.setFont("helvetica", "bold"); // Set font to bold
        const headingY = 75; // Adjust Y-coordinate to where you want it above the table
        doc.text('Format for one-page note on select capex items:', 20, headingY);

        // Set normal font back for the table contents
        doc.setFont("helvetica", "normal");

        // Dynamically populate table data from formData or masterData
        const tableBody = [
            ['#', 'Particulars', 'Details'],
            ['1', 'Machine/ Asset Name', formData.assetName || 'N/A'],
            ['2', 'Model#', formData.model || 'N/A'],
            ['3', 'Serial#', formData.serial || 'N/A'],
            ['4', 'Make/ Manufacturer', formData.manufacturer || 'N/A'],
            ['5', 'Fixed Asset Code/ Asset ID', (formData.assetCode).slice(3) || 'N/A'],
            ['6', 'Building where installed', formData.location || 'N/A'],
            ['7', 'Invoice#', formData.invoice || 'N/A'],
            ['8', 'Invoice date', formData.invoiceDate || 'N/A'],
            ['9', 'Description of Asset as per Invoice', formData.description || 'N/A'],
            ['10', 'Name of Seller/ Vendor', formData.vendor || 'N/A'],
            ['11', 'Status', formData.status || 'N/A'],
            ['12', 'Amount Capitalized (₹)', formData.amountCapitalized || 'N/A'],
        ];

        // doc.autoTable({
        //     startY: 75,  // Positioned after the instructions
        //     // head: [['#', 'Particulars', 'Details']],
        //     body: tableBody,
        //     theme: 'grid',
        //     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        //     margin: { top: 75, left: 20, right: 20 },
        //     styles: { fontSize: 9 },  // Reduce font size in the table to save space
        // });

        // Add the table
        doc.autoTable({
            startY: headingY + 4, // Position the table just below the heading
            // head: [['#', 'Particulars', 'Details']],
            body: tableBody,
            theme: 'grid',
            headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
            margin: { top: 75, left: 20, right: 20 },
            styles: { fontSize: 9 },  // Reduce font size in the table to save space
        });

        // Add Photo of Asset section
        doc.text('Photo of Asset:', 20, doc.lastAutoTable.finalY + 10);

        // Define starting position for the images
        let xPos = 20; // X-coordinate of the first image
        let yPos = doc.lastAutoTable.finalY + 15; // Y-coordinate below the "Photo of Asset" heading
        const maxImageWidth = 50; // Maximum width of each image
        const maxImageHeight = 50; // Maximum height of each image
        const margin = 10; // Margin between images

        // Create an array to hold promises for image loading
        const imagePromises = imagePreviews.map(async (imgDataUrl) => {
            // Create an Image object to get its dimensions
            const img = new Image();
            img.src = imgDataUrl;

            return new Promise((resolve, reject) => {
                img.onload = async () => {
                    // Calculate aspect ratio
                    const aspectRatio = img.width / img.height;
                    let width, height;

                    // Determine width and height based on aspect ratio
                    if (aspectRatio > 1) {
                        // Landscape
                        width = Math.min(maxImageWidth, img.width);
                        height = width / aspectRatio;
                    } else {
                        // Portrait
                        height = Math.min(maxImageHeight, img.height);
                        width = height * aspectRatio;
                    }

                    // Add image to PDF
                    try {
                        await doc.addImage(imgDataUrl, 'JPEG', xPos, yPos, width, height);
                        // Update the xPos for the next image
                        xPos += width + margin;

                        // If the next image will overflow the page width, move to the next row
                        if (xPos + width > doc.internal.pageSize.getWidth() - 20) {
                            xPos = 20; // Reset to start of the row
                            yPos += height + margin; // Move down to the next row
                        }
                        resolve(); // Resolve the promise when done
                    } catch (error) {
                        console.error('Error adding image to PDF:', error);
                        reject(error); // Reject the promise if there's an error
                    }
                };

                img.onerror = () => {
                    console.error('Error loading image:', imgDataUrl);
                    reject(new Error('Image load error'));
                };
            });
        });

        // Wait for all images to load and be added to the PDF
        await Promise.all(imagePromises);

        // Ensure enough space between the last image and the signature section
        yPos += maxImageHeight + margin;

        // Save the PDF
        doc.save('PLI_Form.pdf');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fill all required fields.");
            return; // Stop submission if validation fails
        }

        // Proceed with form submission if no errors
        const payload = {
            submitby_name: username,
            submitby_dept: "",
            vendor_no: masterData['Vendor Code'],
            asset_no: masterData['asset_no'],
            form_data: {
                asset_name: formData.assetName,
                model: formData.model,
                serial_no: formData.serial,
                make: formData.manufacturer,
                asset_code_rfid: formData.assetCode,
                installation_location: formData.location,
                invoice_no: formData.invoice,
                invoice_date: formData.invoiceDate,
                asset_description: formData.description,
                vendor_no: formData.vendor,
                status: formData.status,
                amount_capitalized: formData.amountCapitalized
            }
        };

        try {
            setPostLoading(true);
            const action = dispatch(PliPostLog(payload));
            const res = await action.unwrap();
            if (res.StatusCode === 201) {
                if (fileData.files.length > 0) {
                    await PLIFileUpload(res.result.id);
                }
                setPostLoading(false);
                toast.success("PLI Requested!");
                generatePDF();
                setTimeout(() => {
                    navigate(`/pli-history/${asset_no}`);
                }, 2000);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setPostLoading(false);
        }
    };


    const getAssetMasrter = async () => {
        try {
            const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `asset_no=${asset_no}` }));
            // const action = dispatch(getAssetDataById(asset_no));
            const res = await action.unwrap();
            console.log("ALL DATA", res.result.data)
            if (res.result.data) {
                if (res.result.data.length > 0) {
                    setMasterData(res.result.data[0])
                    const assetData = res.result.data[0];

                    // Update form data with the fetched asset data
                    setFormData({
                        assetCode: assetData['asset_no'] || '',
                        description: assetData['asset_text'] || '',

                    });
                } else {
                    toast.info("Asset Not Found!")
                }
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Asset Not Found!");
        }
    }
    // Clean up object URLs to prevent memory leaks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const revokeObjectUrls = () => {
        imagePreviews.forEach(url => URL.revokeObjectURL(url)); // Clean up each object URL
    };

    // Call revokeObjectUrls when component unmounts or new files are selected
    useEffect(() => {
        return () => {
            revokeObjectUrls(); // Clean up when component unmounts
        };
    }, [imagePreviews, revokeObjectUrls]);


    useEffect(() => {
        const fetchData = async () => {
            await getAssetMasrter();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }


    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        PLI Physical Verification Form
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="PLI Physical Verification Form" />
                </Box>
                <Box>

                    {/* Instructions Section */}
                    <Card className={classes.instructionCard}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Photographs should include the following:
                            </Typography>
                            <Typography className={classes.instructionText}>
                                i. Few photos of factory entrance with GPS coordinates.
                            </Typography>
                            <Typography className={classes.instructionText}>
                                ii. External and internal view of factory including manufacturing operations.
                            </Typography>
                            <Typography className={classes.instructionText}>
                                iii. Photo of visiting team from CE and Company officials.
                            </Typography>
                            <Typography className={classes.instructionText}>
                                iv. A one-page note covering capex items – sample of at least 30 high value/critical items of Eligible Investment in the format provided below:
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
                <Box mb={2}>
                    <Grid container>
                        <form className={classes.form}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Machine/ Asset Name"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.assetName}
                                        error={!!formErrors.assetName}
                                        helperText={formErrors.assetName}
                                        required
                                        onChange={(e) => setFormData({ ...formData, assetName: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Model"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.model}
                                        error={!!formErrors.model}
                                        helperText={formErrors.model}
                                        required
                                        onChange={(e) => setFormData({ ...formData, model: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Serial"
                                        name="serial"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.serial}
                                        error={!!formErrors.serial}
                                        helperText={formErrors.serial}
                                        required
                                        onChange={(e) => setFormData({ ...formData, serial: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Make/ Manufacturer"
                                        name="Make/Manufacturer"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.manufacturer}
                                        error={!!formErrors.manufacturer}
                                        helperText={formErrors.manufacturer}
                                        required
                                        onChange={(e) => setFormData({ ...formData, manufacturer: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Fixed Asset Code/ Asset ID"
                                        name="Fixed Asset Code/ Asset ID"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={(formData.assetCode).slice(3)}
                                        error={!!formErrors.assetCode}
                                        helperText={formErrors.assetCode}
                                        required
                                        inputProps={{ readOnly: true }}
                                        onChange={(e) => setFormData({ ...formData, assetCode: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Building where installed (Applicant’s Plant or Vendor location)"
                                        name="CurrentLocation"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.location}
                                        error={!!formErrors.location}
                                        helperText={formErrors.location}
                                        required
                                        onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Invoice"
                                        name="Invoice"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.invoice}
                                        error={!!formErrors.invoice}
                                        helperText={formErrors.invoice}
                                        required
                                        onChange={(e) => setFormData({ ...formData, invoice: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Invoice date"
                                        name="Invoice date"
                                        variant="outlined"
                                        fullWidth
                                        type='date'
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.invoiceDate}
                                        error={!!formErrors.invoiceDate}
                                        helperText={formErrors.invoiceDate}
                                        required
                                        onChange={(e) => setFormData({ ...formData, invoiceDate: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Description of Asset as per Invoice"
                                        name="Description of Asset as per Invoice"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.description}
                                        error={!!formErrors.description}
                                        helperText={formErrors.description}
                                        required
                                        inputProps={{ readOnly: true }}
                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Name of Seller/ Vendor"
                                        name="Name of Seller/ Vendor"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.vendor}
                                        error={!!formErrors.vendor}
                                        helperText={formErrors.vendor}
                                        required
                                        onChange={(e) => setFormData({ ...formData, vendor: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Status (Running/ Idle/ Under maintenance/ To be commissioned/ etc.)"
                                        name="Status (Running/ Idle/ Under maintenance/ To be commissioned/ etc.)"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                        value={formData.status}
                                        error={!!formErrors.status}
                                        helperText={formErrors.status}
                                        required
                                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Amount Capitalized (₹)"
                                        name="Amount Capitalized (₹)"
                                        variant="outlined"
                                        fullWidth
                                        value={formData.amountCapitalized}
                                        error={!!formErrors.amountCapitalized}
                                        helperText={formErrors.amountCapitalized}
                                        required
                                        onChange={(e) => setFormData({ ...formData, amountCapitalized: e.target.value })}
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </form>

                    </Grid>
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Attachments
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <input type="file" hidden id="fileInput" multiple accept=".jpeg, .jpg, .gif, .png, .tiff, .bmp" onChange={handleFileChange} />
                            <label htmlFor="fileInput">
                                <Button variant="contained" component="span" color="primary"
                                    disabled={fileData.files.length >= MAX_IMAGES}>
                                    Select File
                                </Button>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{ marginTop: 8 }}
                                >
                                    Note - only 3 image with these formats (JPEG, GIF, PNG, TIFF, BMP) can be attached.
                                </Typography>
                            </label>
                            {/* {uploading && <Container>
                                <Box display="flex" justifyContent="center">
                                    File Uploading....
                                    <CircularProgress />
                                </Box>
                            </Container>} */}
                            {uploading && (
                                <Container>
                                    <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                        <Typography variant="body1" mr={2}>
                                            File Uploading...
                                        </Typography>
                                        <CircularProgress />
                                    </Box>
                                </Container>
                            )}
                        </Grid>
                    </Grid>
                    {/* Image preview section */}
                    <Grid container spacing={2}>
                        {imagePreviews.length > 0 && <Grid item xs={6} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Photo of Asset:
                            </Typography>
                        </Grid>}
                        {imagePreviews.map((preview, index) => (
                            <Grid item xs={6} sm={4} key={index}>
                                <Box>
                                    <img
                                        src={preview}
                                        alt={`preview-${index}`}
                                        style={{
                                            width: '100%',  // Make the image take the full width of its container
                                            height: '200px',  // Set a fixed height for all images
                                            objectFit: 'contain',  // Preserve aspect ratio and show the entire image
                                            borderRadius: '8px',
                                            border: '1px solid #ccc',
                                            padding: '5px',
                                            backgroundColor: '#f0f0f0',  // Add background to fill the empty space when the image doesn't cover the container
                                        }}
                                    />
                                    {/* Remove button */}
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => handleRemoveImage(index)}
                                        style={{ marginTop: '10px' }}
                                    >
                                        Remove
                                    </Button>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Digital Signature
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <input
                                type="file"
                                hidden
                                id="UploadSign"
                                accept="image/*"
                                onChange={handleSignUpload}
                            />
                            <label htmlFor="UploadSign">
                                <Button variant="contained" component="span" color="primary">
                                    Upload Signature
                                </Button>
                            </label>
                            {signaturePreview && (
                                // <Box mt={2}>
                                //     <img
                                //         src={signaturePreview}
                                //         alt="Signature Preview"
                                //         style={{
                                //             width: '100%',
                                //             height: 'auto',
                                //             borderRadius: '8px',
                                //             border: '1px solid #ccc',
                                //             padding: '5px',
                                //         }}
                                //     />
                                // </Box>
                                <Grid item xs={6} sm={4}>
                                    <Box mt={2}>
                                        <img
                                            src={signaturePreview}
                                            alt="Signature Preview"
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                borderRadius: '8px',
                                                border: '1px solid #ccc',
                                                padding: '5px'
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Box> */}
                {/* <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            className={classes.formControl}
                            label="Name"
                            name="name"
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: true, // Ensures the label doesn't overlap when field is populated
                            }}
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            className={classes.formControl}
                            label="Designation"
                            name="Designation"
                            variant="outlined"
                            fullWidth
                            value={formData.designation}
                            onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
                            InputLabelProps={{
                                shrink: true, // Ensures the label doesn't overlap when field is populated
                            }}
                        />
                    </Grid>
                </Grid> */}
                <Grid container style={{ marginTop: '10px' }}>
                    <Grid item>
                        <Button
                            className={classes.button}
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            fullWidth
                            size='large'
                            startIcon={postLoading && <CircularProgress size={20} />}
                            disabled={postLoading}
                        >
                            {postLoading ? "Submitting" : "Submit"}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default PLIForm;
